import { memo } from 'react';

import SidebarWithHeader from './sidebarWithHeader/SidebarWithHeader';
import { useIncomingVideoCall } from '../../hooks/useIncomingVideoCall';
import { IncomingCallModal } from '../modals/IncomingCallModal';
import { UnreadEventsProvider } from '../../context/UnreadEventsContext';
import { WebSocketProvider } from '../../context/WebSocketContext';
import { GlobalSocketListener } from './GlobalSocketListener';

const LayoutMenuContent = ({ children }) => {
	const { incomingCall, acceptCall, declineCall } = useIncomingVideoCall();

	return (
		<UnreadEventsProvider>
			<GlobalSocketListener />
				<SidebarWithHeader>{children}</SidebarWithHeader>
			<IncomingCallModal
				isOpen={!!incomingCall}
				callData={incomingCall}
				onAccept={acceptCall}
				onDecline={declineCall}
			/>
		</UnreadEventsProvider>
	);
};

// eslint-disable-next-line react/display-name
export const LayoutMenu = memo(({ children }) => {
	return (
		<WebSocketProvider>
			<LayoutMenuContent>{children}</LayoutMenuContent>
		</WebSocketProvider>
	);
});
